export default "__VITE_ASSET__B2Nd11km__"